import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { OrderHistoryProductModel } from "@store/Types/ApiModels";

interface Parameter {
    lineId: string;
    qtyOrdered: number;
    product: OrderHistoryProductModel;
}

type HandlerType = Handler<Parameter>;

export const DispatchCompleteChangeQty: HandlerType = ({ parameter: { lineId, qtyOrdered }, dispatch }) => {
    const untypedDispatch = dispatch as any;
    untypedDispatch({
        type: "Pages/Rma/ChangeProductQtyOrdered",
        lineId,
        qtyOrdered,
    });
};

export const chain = [DispatchCompleteChangeQty];

const changeProductQty = createHandlerChainRunner(chain, "ChangeProductQty");
export default changeProductQty;
